if (!customElements.get('pairs-with')) {
  class ComponentPairsWith extends HTMLElement {
    constructor() {
      super();

      this.boundSyncAllPairProducts = this.syncAllPairProducts.bind(this);

      this.addEventListener('click', (event) => {
        var addBtn = event.target.closest('.toggle-add');
        if (addBtn) {
          this.addPairProduct(addBtn);
          return;
        }
        var checkBtn = event.target.closest('.btn.check');
        if (checkBtn) {
          this.removePairProduct(checkBtn);
        }
      });

      this.querySelectorAll('product-card-atc').forEach((productCard) => {
        productCard.addEventListener('variantChange', (event) => {
          this.onPairVariantChange(productCard, event.detail && event.detail.variant);
        });
      });

      window.addEventListener('CartCache:changed', this.boundSyncAllPairProducts);
      setTimeout(() => {
        this.querySelectorAll('product-card-atc').forEach((productCard) => {
          this.onPairVariantChange(productCard, this.getVariantFromProductCard(productCard));
        });
      }, 100);
    }

    disconnectedCallback() {
      window.removeEventListener('CartCache:changed', this.boundSyncAllPairProducts);
    }

    getProductCard(btn) {
      return btn.closest('product-card-atc');
    }

    getVariantInput(productCard) {
      return productCard?.querySelector('[data-variant-id], input[name="id"]');
    }

    buildAddData(productCard) {
      const variantInput = this.getVariantInput(productCard);
      if (!variantInput?.value) {
        return null;
      }
      const data = new FormData();
      data.append('id', variantInput.value);
      data.append('quantity', 1);
      const sellingPlan = productCard.querySelector('[name="selling_plan"]');
      if (sellingPlan?.value) {
        data.append('selling_plan', sellingPlan.value);
      }
      return data;
    }

    isVariantInCart(cart, variantId) {
      if (!cart?.items?.length || !variantId) {
        return false;
      }
      const parsedVariantId = parseInt(variantId, 10);
      return cart.items.some((item) => item.variant_id === parsedVariantId);
    }

    getVariantFromProductCard(productCard, preferredVariant) {
      if (preferredVariant) {
        return preferredVariant;
      }
      if (!productCard) {
        return null;
      }
      if (typeof productCard.getCurrentVariant === 'function') {
        var currentVariant = productCard.getCurrentVariant();
        if (currentVariant) {
          return currentVariant;
        }
      }
      var variantId = this.getVariantInput(productCard)?.value;
      if (!variantId || !productCard.productData?.variants) {
        return null;
      }
      return productCard.productData.variants.find(function(variant) {
        return variant.id == variantId;
      }) || null;
    }

    isVariantAvailable(variant) {
      return !!(variant && variant.available);
    }

    showSoldOutState(productCard) {
      if (!productCard) {
        return;
      }
      var addBtn = productCard.querySelector('.toggle-add');
      var checkBtn = productCard.querySelector('.btn.check');
      var soldOutMessage = productCard.querySelector('.sold-out-message');
      if (addBtn) {
        addBtn.classList.add('hide');
      }
      if (checkBtn) {
        checkBtn.classList.add('hide');
      }
      if (soldOutMessage) {
        soldOutMessage.style.display = 'block';
        soldOutMessage.classList.add('is-active');
      }
      productCard.classList.add('is-sold-out');
      productCard.classList.remove('checked');
    }

    showAvailableAddState(productCard) {
      if (!productCard) {
        return;
      }
      var addBtn = productCard.querySelector('.toggle-add');
      var checkBtn = productCard.querySelector('.btn.check');
      var soldOutMessage = productCard.querySelector('.sold-out-message');
      if (soldOutMessage) {
        soldOutMessage.style.display = 'none';
        soldOutMessage.classList.remove('is-active');
      }
      productCard.classList.remove('is-sold-out');
      if (checkBtn) {
        checkBtn.classList.add('hide');
      }
      if (addBtn) {
        addBtn.classList.remove('hide');
      }
      productCard.classList.remove('checked');
    }

    showCheckmark(productCard) {
      var addBtn = productCard?.querySelector('.toggle-add');
      var checkBtn = productCard?.querySelector('.btn.check');
      if (!addBtn || !checkBtn) {
        return;
      }
      var soldOutMessage = productCard.querySelector('.sold-out-message');
      if (soldOutMessage) {
        soldOutMessage.style.display = 'none';
        soldOutMessage.classList.remove('is-active');
      }
      productCard.classList.remove('is-sold-out');
      checkBtn.classList.remove('hide');
      addBtn.classList.add('hide');
      productCard.classList.add('checked');
    }

    applyCartState(productCard, cart, variant) {
      if (!productCard) {
        return;
      }
      variant = this.getVariantFromProductCard(productCard, variant);
      if (!this.isVariantAvailable(variant)) {
        this.showSoldOutState(productCard);
        return;
      }
      var variantId = this.getVariantInput(productCard)?.value;
      if (this.isVariantInCart(cart, variantId)) {
        this.showCheckmark(productCard);
      } else {
        this.showAvailableAddState(productCard);
      }
    }

    onPairVariantChange(productCard, preferredVariant) {
      if (!productCard) {
        return;
      }
      var variant = this.getVariantFromProductCard(productCard, preferredVariant);
      if (!this.isVariantAvailable(variant)) {
        this.showSoldOutState(productCard);
        return;
      }
      this.showAvailableAddState(productCard);
      var variantId = variant && variant.id;
      var syncToken = String(Date.now());
      productCard.dataset.pairsWithSyncToken = syncToken;
      $s.getJson({ url: '/cart.js' }).then((cart) => {
        if (productCard.dataset.pairsWithSyncToken !== syncToken) {
          return;
        }
        if (this.getVariantInput(productCard)?.value != variantId) {
          return;
        }
        this.applyCartState(productCard, cart, variant);
      });
    }

    syncAllPairProducts() {
      var productCards = this.querySelectorAll('product-card-atc');
      if (!productCards.length) {
        return;
      }
      $s.getJson({ url: '/cart.js' }).then((cart) => {
        productCards.forEach((productCard) => {
          this.applyCartState(productCard, cart, this.getVariantFromProductCard(productCard));
        });
      });
    }

    addPairProduct(btn) {
      const productCard = this.getProductCard(btn);
      const variant = this.getVariantFromProductCard(productCard);
      if (!productCard || productCard.classList.contains('checked') || !this.isVariantAvailable(variant)) {
        return;
      }
      const formElements = productCard.querySelectorAll('[name]');
      if (Array.from(formElements).some((element) => element.reportValidity && !element.reportValidity())) {
        return;
      }
      const data = this.buildAddData(productCard);
      if (!data) {
        return;
      }

      $s.showLoadingOverlay();
      $s.post({
        url: routes.cart_url + '/add.js',
        data: data,
        success: () => {
          this.showCheckmark(productCard);
          $s.addToCartSuccess();
        },
        error: (response) => {
          $s.addToCartFail(response?.description || response);
        }
      });
    }

    removePairProduct(btn) {
      const productCard = this.getProductCard(btn);
      const variantId = this.getVariantInput(productCard)?.value;
      if (!variantId) {
        this.onPairVariantChange(productCard, this.getVariantFromProductCard(productCard));
        return;
      }

      $s.showLoadingOverlay();
      $s.post({
        url: routes.cart_url + '/change.js',
        data: { id: variantId, quantity: 0 },
        success: () => {
          this.onPairVariantChange(productCard, this.getVariantFromProductCard(productCard));
          if (window.SideCart) {
            window.SideCart.updateSideCart(true);
          } else {
            $s.hideLoadingOverlay();
          }
        },
        error: (response) => {
          $s.addToCartFail(response?.description || response);
        }
      });
    }
  }
  customElements.define('pairs-with', ComponentPairsWith);
}
